import { render, staticRenderFns } from "./BalanceHeaderSet.vue?vue&type=template&id=f0da8c72&scoped=true&"
import script from "./BalanceHeaderSet.vue?vue&type=script&lang=ts&"
export * from "./BalanceHeaderSet.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceHeaderSet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BalanceHeaderSet.vue?vue&type=style&index=1&id=f0da8c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0da8c72",
  null
  
)

export default component.exports